import { useState } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Button,
  Text,
  VStack,
  HStack,
  Box,
  ModalFooter,
  Center,
} from '@chakra-ui/react';
import Datetime from 'react-datetime';
import moment from 'moment';
import { ScheduleModalProps } from './types';

export default function ScheduleModal({ isOpen, onClose, onSchedule }: ScheduleModalProps) {
  const [selectedDate, setSelectedDate] = useState<Date>(new Date());

  const handleSchedule = () => {
    onSchedule(selectedDate);
    onClose();
  };

  const displayTimeDiff = () => {
    const now = moment();
    const selected = moment(selectedDate);
    return ` ${selected.from(now)}`;
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent p={4}>
        <ModalHeader>Schedule this post</ModalHeader>
        <ModalCloseButton />
        <ModalBody pb={6}>
          <VStack spacing={6} align="stretch">
            <Box>
              <Text textAlign="center" fontWeight="700">
                Pick a time slot
              </Text>
              <Center m={5}>
                <Button variant="outline" p={0} width="200px">
                  <Datetime
                    isValidDate={(current) => {
                      const yesterday = moment().subtract(1, 'day');
                      return current.isAfter(yesterday);
                    }}
                    value={selectedDate}
                    className="customDateTime"
                    onChange={(d) => {
                      if (d && typeof d !== 'string' && d.toDate) {
                        setSelectedDate(d.toDate());
                      }
                    }}
                  />
                </Button>
              </Center>
              <Text textAlign="center">
                Will be published<b>{displayTimeDiff()}</b>
              </Text>
            </Box>
          </VStack>
        </ModalBody>
        <ModalFooter px={0} pb={0}>
          <HStack justify="space-between" width="100%">
            <Button
              variant="ghost"
              onClick={onClose}
              textDecoration="underline"
            >
              Cancel
            </Button>
            <Button
              variant="primary"
              onClick={handleSchedule}
            >
              Schedule
            </Button>
          </HStack>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
} 